import React, { useEffect, useState } from "react";
import searcher from "../../assets/searchInput.svg";
import CreateBtn from "../../components/buttons/createBtn";
import VersionHistoryBtn from "../../components/buttons/versionHistoryBtn";
import CFATable from "./CFA-list-table";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const CFAList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "CFA" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/cfa",
      breadcrumb: " / cfa",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div className="">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div className="search-box d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  value={search}
                  className="search-input text-dark fw_400 px-2"
                  type="text"
                  placeholder="Search CFA Id, CFA name, Firm Name, etc,."
                  onChange={(e) => {
                    navigate(
                      `/cfa?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                />
              </div>

              <div className=" d-flex justify-content-between m-1 mb-2">
                <button
                  onClick={() => navigate(`/cfa`)}
                  className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                >
                  Clear Filters
                </button>
                <VersionHistoryBtn link="/cfa/version-history" />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <CreateBtn link="/cfa/create" />
                ) : (
                  ""
                )}
              </div>
            </div>
            <CFATable search={search} status={status} page_no={page_no} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CFAList;
